export const getApiUrl = (): string => {
  switch (process.env.GAMIPHY_ENV) {
    case 'prod':
      return 'https://api.coretava.com';
    case 'staging':
      return 'https://api.staging.coretava.com';
    default:
      return 'https://api.dev.coretava.com';
  }
};

export const getStaticUri = (): string => {
  switch (process.env.GAMIPHY_ENV) {
    case 'prod':
      return 'https://static.gamiphy.co';
    case 'staging':
      return 'https://static-staging.gamiphy.co';
    default:
      return 'https://static-dev.gamiphy.co';
  }
};

export const getCoreLoyaltySdkUrl = (): string => `${getStaticUri()}/sdk/loyalty-station/main.js`;
